/**
 * Created by afuhr on 20.09.2016.
 */
import {makeTypedFactory} from "typed-immutable-record";
import {ISelectedStock, ISelectedStockRecord} from "./stock.types";

export const StockFactory = makeTypedFactory<ISelectedStock, ISelectedStockRecord>({
  selectedStock: null
});

export const INITIAL_STATE = StockFactory();



// WEBPACK FOOTER //
// ./src/app/shared/redux-store/store-management/stock/stock.initial-state.ts